export const getFlightStatus = (flight) => {
  let ETD = flight.ETD
  let ETA = flight.ETA
  let dep = flight.originalDeparture ? flight.originalDeparture : flight.Departure

  // NOTE // priority is cancelled, delayed, active
  if (flight.NOPAX === "1") {
    return 'Cancelled'
  }
  // NOTE // if the flight has an estimated time of departure (ETD) and an estimated time of arrival (ETA), check if it's delayed
  else if (ETD && ETA) {
    let ETDTime = new Date(ETD).getTime()
    // NOTE // gets the time in ms for the ETD (estimated time of departure)
    let depTime = new Date((ETD.slice(0, 11) + ' ' + dep)).getTime()
    // NOTE // if the estimated time of departure (ETD) is after departure it's delayed
    if (ETDTime > depTime) {
      return 'Delayed'
    }
    else if (ETDTime < depTime) {
      return 'Preponded'
    }
    // NOTE // if there is an ETA/ETD that are the same as the original arrival/dep time, it's active
    return 'Active'
  }
  else {
    return 'Active'
  }
}